import PropTypes from 'prop-types';

import { BlogPostTileType } from 'utilities/propTypes';
import Grid from 'components/grid/grid';
import BlogPostTile from './BlogPostTile';

const BlogPosts = (props) => {
  const { posts } = props;
  return (
    <Grid>
      {posts.map((post) => {
        return <BlogPostTile post={post} key={post.id}></BlogPostTile>;
      })}
    </Grid>
  );
};

export default BlogPosts;

BlogPosts.propTypes = {
  posts: PropTypes.arrayOf(BlogPostTileType).isRequired,
};
